import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal"; 
import { Context } from "../contexts/AppContext";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../lib/utils"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';

import io from "socket.io-client";


function WatchOnTvModal() {
    //http://192.168.181.194:5001 this ip for my phone hotspot
  //http://192.168.1.196:5001 ye bhmi or k wifi ka IP hai 
 const socket = io("http://192.168.1.6:5001"); // backend IP
 const { value } = useContext(Context);

 const [appState, setAppState] = value; 
  const [modalOpen, setModalOpen] = useState(appState.modalData);
   const [code, setCode] = useState(["", "", "", "", "", ""]); // 🔹 Store 6 characters
  const [isButtonEnabled, setIsButtonEnabled] = useState(false); // 🔹 Track button state


  useEffect(() => {
  socket.on("connect", () => {
    console.log("Web client connected:", socket.id);
    socket.emit("register-web"); // Backend ko batana ki ye web client hai
  });
  
  // Optional cleanup
  return () => {
    socket.off("connect");
  };
}, []);

 useEffect(() => {
   setModalOpen(appState.modalData); // modalOpen को अपडेट करें
 }, [appState.modalData]);


 console.log("app state xxx",appState?.videoArr)
  
 
  
  const [folderName, setFolderName] = useState("");

   useEffect(() => {
    // 🔹 Enable button only if all 6 digits are filled
    setIsButtonEnabled(code.every((char) => char.trim() !== ""));
  }, [code]);

  const handleChange = (e, index) => {
    const value = e.target.value.toUpperCase().slice(0, 1); // allow 1 character only
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // 🔹 Move to next input automatically
    if (value && index < 5) {
      document.getElementById(`tv-connect-input-${index + 1}`).focus();
    }
  };

 const handleSubmit = (e) => {
  e.preventDefault();

  const enteredCode = code.join("");
  console.log("Entered TV Code:", enteredCode);
  console.log("CCCCCCCCC11 ",appState?.currentGalleryData?._id)

   

  // ✅ Emit with correct code string
  socket.emit("pair-tv", { code: enteredCode, galleryId: appState?.currentGalleryData?._id });

  alert("Pair request sent");

  // 🔹 You can add your API call or additional pairing logic here
};

  Modal.setAppElement("#root");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "800px",
      height: "auto",
      width: "100%",
      overflow: "hidden",
  
      backgroundColor:'lightgray',
      borderRadius:"10px"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  };
 
  const closeModal = () => {
    console.log("CLOSE MODAL11111")
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false}};
    }); 

 

  }

 
 
  return (
    <Modal
      isOpen={modalOpen.isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="New Folder Modal"
    >
      
  
 <div
      className="w-full relative p-5 pb-0 pt-2 bg-white rounded"
      style={{ opacity: 1, willChange: "auto", transform: "none" }}
    >
      <div className="w-full border-b pb-2 flex items-center justify-between">
        <div className="flex items-center">
          <div className="text-base text-gray-600 font-bold app-font-bold" >
            Watch on TV
          </div>
          <div className="w-4" />
          {/*
          <a
            className="w-16 py-1 rounded text-sm text-center bg-primary-50 text-primary-500 border-2 border-primary-50 font-semibold app-font hover:border-primary-200"
            href="https://help.vidflix.co/article/35-watch-on-smart-tvs"
            target="_blank"
          >
            Help?
          </a>*/}
        </div>
        <button className="w-10 h-10 text-lg text-gray-500 rounded hover:bg-gray-100" onClick={closeModal}>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="xmark"
            className="svg-inline--fa fa-xmark"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
          >
            <path
              fill="currentColor"
              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
            />
          </svg>
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="w-full border-b md:border-r md:border-b-0 px-0 sm:px-3 py-5 sm:my-5">
          <div className="h-2" />
          <div className="w-full py-1 text-center text-gray-800 text-base font-medium app-font">
            View on the big screen,
          </div>
          <div className="w-full py-1 text-center text-gray-900 text-2xl mb-2 font-bold app-font-bold">
            with the vidflix TV App
          </div>
          <div className="py-1 hidden tv-image md:block tv-graphic">
             
          </div>
          <div className="py-1 hidden md:block">
            <img
              alt="platforms"
              loading="lazy"
              className="w-full mx-auto h-auto"
              src="/img/vidflix.jpg"
              style={{ color: "transparent" }}
            />
          </div>
          <div className="py-2">
            <a
              
              target="_blank"
              className="flex w-full border-2 text-gray-500 font-semibold app-font-bold leading-10 rounded transition-all hover:text-primary-500 hover:border-primary-200"
            >
              <div className="w-full flex items-center justify-center">
                <div className="mr-2">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="square-arrow-up-right"
                    className="svg-inline--fa fa-square-arrow-up-right"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32h320zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
                    />
                  </svg>
                </div>
                <div>View All TVs & Devices</div>
              </div>
            </a>
          </div>
        </div>

        <div className="w-full px-0 sm:px-3 py-5 sm:py-10">
          <div className="w-full md:w-10/12 mx-auto">
            <div className="w-full text-gray-800 app-font-bold">
              {["Search for vidflix on your TV's app store", "Install & launch the app on your TV", "Enter the Code shown on screen below:"].map((step, index) => (
                <div className="flex items-center mb-4" key={index}>
                  <div className="w-8 h-8 text-center rounded-full bg-[#114132] text-white leading-8 font-semibold mr-3">
                    {index + 1}
                  </div>
                  <div className="font-semibold text-xs sm:text-base">
                    {index === 0 ? <>vidflix  on your TV's app store</> : step}
                  </div>
                </div>
              ))}
            </div>

            <div className="w-full h-6" />

            <div className="w-full">
                <form onSubmit={handleSubmit}>
              <div className="flex justify-center mb-6">
                {[...Array(6)].map((_, i) => (
                  <React.Fragment key={i}>
                    <input
                      id={`tv-connect-input-${i}`}
                      type="text"
                      maxLength="1"
                      className="w-10 text-center uppercase text-2xl leading-10 p-1 mx-1 outline-none focus:border-green-700 border border-gray-300 rounded bg-gray-200"
                      value={code[i]}
                      onChange={(e) => handleChange(e, i)}
                    />
                    {i < 5 && <span className="text-gray-400">-</span>}
                  </React.Fragment>
                ))}
              </div>

              <button
                type="submit"
                disabled={!isButtonEnabled}
                className={`w-full py-2 rounded text-white font-medium ${
                  isButtonEnabled
                    ? "bg-green-700 hover:bg-green-800"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
              >
                Add to TV
              </button>
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>


  
    </Modal>
  );
}

export default WatchOnTvModal;
